var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.00003H17V3.00003H7V5.00003H5C3.9 5.00003 3 5.90003 3 7.00003V8.00003C3 10.55 4.92 12.63 7.39 12.94C8.02 14.44 9.37 15.57 11 15.9V19H7V21H17V19H13V15.9C14.63 15.57 15.98 14.44 16.61 12.94C19.08 12.63 21 10.55 21 8.00003V7.00003C21 5.90003 20.1 5.00003 19 5.00003ZM5 8.00003V7.00003H7V10.82C5.84 10.4 5 9.30003 5 8.00003ZM12 14C10.35 14 9 12.65 9 11V5.00003H15V11C15 12.65 13.65 14 12 14ZM19 8.00003C19 9.30003 18.16 10.4 17 10.82V7.00003H19V8.00003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnings);
export default __webpack_public_path__ + "static/media/winnings.52b9f153291a6b170de452613d73850f.svg";
export { ForwardRef as ReactComponent };